import React from "react";
// import financialData from "../../data/financial.json";
import { DollarSign, TrendingUp } from "lucide-react";
import StyledTooltip from "../../common/StyledTooltip";

export default function IncomeBreakdownCards({ data }) {
  const incomeCards = [
    {
      title: "Principal Amount",

      amount: data?.financialBreakdown?.principal?.display || "₹0",
      originalValue: data?.financialBreakdown?.principal?.amount || 0,

      percent: data?.financialBreakdown?.principal?.percentage + "%" || "0%",

      color: "#155DFC",

      bg: "#ffffff",
    },

    {
      title: "Interest Income",

      amount: data?.financialBreakdown?.interest?.display || "₹0",
      originalValue: data?.financialBreakdown?.interest?.amount || 0,

      percent: data?.financialBreakdown?.interest?.percentage + "%" || "0%",

      color: "#00A63E",

      bg: "#ffffff",
    },

    {
      title: "Processing Fee Income",

      amount: data?.financialBreakdown?.processingFee?.display || "₹0",
      originalValue: data?.financialBreakdown?.processingFee?.amount || 0,

      percent:
        data?.financialBreakdown?.processingFee?.percentage + "%" || "0%",

      color: "#9810FA",

      bg: "#ffffff",
    },

    {
      title: "Other Charges",

      amount: data?.financialBreakdown?.charges?.display || "₹0",
      originalValue: data?.financialBreakdown?.charges?.amount || 0,

      percent: data?.financialBreakdown?.charges?.percentage + "%" || "0%",

      color: "#F59E0B",

      bg: "#ffffff",
    },
  ];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4,1fr)",
        gap: window.innerWidth > 1800 ? "30px" :"20px",
      }}
    >
      {incomeCards && incomeCards?.length > 0 && incomeCards?.map((card, index) => (
        <div
          key={index}
          style={{
            background: "#FFFFFF",
            borderRadius: "10px",
            padding: "18px",
            border: "0.8px solid #E5E7EB",
            boxShadow:
              "0px 1px 1px rgba(0,0,0,0.08), 0px 1px 2px rgba(0,0,0,0.06)",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                background: card.bg,
                color: card.color,
                width: "48px",
                height: "48px",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              <DollarSign color={card.color} />
            </div>

            <span style={{ color: card.color }}>
              <TrendingUp />
            </span>
          </div>

          <h6
            style={{
              fontSize: window.innerWidth >= 1800 ? "16px" :   "14px",
              color: "#4A5565",
              margin: "8px 0px 0px 0px",
              fontWeight: "400",
            }}
          >
            {card?.title}
          </h6>

          <StyledTooltip value={card.originalValue}>
            <h6
              style={{
                fontSize: window.innerWidth >= 1800 ? "26px" : "16px",
                fontWeight: "700",
                color: card.color,
                margin: "0",
              }}
            >
              {card.amount}
            </h6>
          </StyledTooltip>

          <h6
            style={{
              fontSize: window.innerWidth >= 1800 ? "16px" : "14px",
              color: "#64748b",
              fontWeight: "400",
              marginBottom: "0px",
            }}
          >
            {card.percent}
          </h6>
        </div>
      ))}
    </div>
  );
}
